<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5 6.5h6.75V5c0-.63-.22-1.16-.66-1.6A2.17 2.17 0 0 0 9 2.76c-.63 0-1.16.22-1.6.66-.43.43-.65.96-.65 1.59h-1.5c0-1.04.37-1.92 1.1-2.65A3.61 3.61 0 0 1 9 1.25c1.04 0 1.92.37 2.65 1.1.73.73 1.1 1.61 1.1 2.65v1.5h.75c.41 0 .77.15 1.06.44.3.3.44.65.44 1.06v7.5c0 .41-.15.77-.44 1.06-.3.3-.65.44-1.06.44h-9c-.41 0-.77-.15-1.06-.44-.3-.3-.44-.65-.44-1.06V8c0-.41.15-.77.44-1.06.3-.3.65-.44 1.06-.44Zm0 9h9V8h-9v7.5ZM9 13.25c.41 0 .77-.15 1.06-.44.3-.3.44-.65.44-1.06 0-.41-.15-.77-.44-1.06-.3-.3-.65-.44-1.06-.44-.41 0-.77.15-1.06.44-.3.3-.44.65-.44 1.06 0 .41.15.77.44 1.06.3.3.65.44 1.06.44Z"
    />
  </svg>
</template>
